module.exports = {
  DEFAULT_PROJECTION: 'globe',
  DEFAULT_STYLE: 'Streets light',
  DEFAULT_DARK_FEATURE_COLOR: '#555',
  DEFAULT_LIGHT_FEATURE_COLOR: '#e8e8e8',
  DEFAULT_SATELLITE_FEATURE_COLOR: '#00f900',
  NEARMAP_API_KEY: 'NDY2ZTlhYzYtZGYzNC00YWMyLWI0OGEtNzg2YzlmNGY1NmNm'
};
